import React, { useEffect } from "react";

import Stack from "@mui/material/Stack";

import FirstActionTracker from "components/first-action-tracker";
import { useNeonNow } from "components/neon-now/use-neon-now.hook";
import { useCallLogDrawer } from "features/calls/call-log-drawer/use-call-log-drawer";
import { usePatientDrawer } from "features/patients/patient-drawer";
import SunoDialer from "features/suno-dialer";
import { AlertBarProvider } from "hooks/use-alert-bar.hook";
import useAuth from "hooks/use-authorize.hook";
import { PrivacyModeProvider } from "hooks/use-patient-privacy.hook";
import { TouchpointsCountProvider } from "hooks/use-touchpoints-count";
import { CurrentCallContextProvider } from "hooks/use-twilio-call-context";
import { TwilioContextProvider } from "hooks/use-twilio-context.hook";
import { useLazyGetTextTemplatesQuery } from "services/text-templates";

import LayoutMainContent from "./layout-main-content";
import LayoutSideMenu from "./layout-side-menu";

export default function Layout() {
  const { isOpen: isPatientDrawerOpen } = usePatientDrawer();
  const { isOpen: isCallLogDrawerOpen } = useCallLogDrawer();
  const { isOpen: isNeonNowDrawerOpen } = useNeonNow();

  useAuth();

  // preload text template names to use in WordProcessor field
  const [triggerLazyGetTextTemplatesQuery] = useLazyGetTextTemplatesQuery();
  useEffect(() => {
    triggerLazyGetTextTemplatesQuery({
      query: "{id,name,type,category}"
    });
  }, [triggerLazyGetTextTemplatesQuery]);

  return (
    <FirstActionTracker actionName="main_app">
      <TouchpointsCountProvider>
        <Stack
          className="app-layout"
          direction="row"
          height="100%"
          sx={{
            width: "100vw",
            height: "100vh"
          }}
        >
          <LayoutSideMenu />
          <AlertBarProvider>
            <PrivacyModeProvider>
              <TwilioContextProvider>
                <LayoutMainContent
                  isDrawerOpen={
                    isPatientDrawerOpen ||
                    isCallLogDrawerOpen ||
                    isNeonNowDrawerOpen
                  }
                />
                <CurrentCallContextProvider>
                  <SunoDialer />
                </CurrentCallContextProvider>
              </TwilioContextProvider>
            </PrivacyModeProvider>
          </AlertBarProvider>
        </Stack>
      </TouchpointsCountProvider>
    </FirstActionTracker>
  );
}
